/** Avis du serveur portés par une réponse (`ExerciseOut.notices` après un enregistrement des Données initiales ou
 *  un import, docs/14 §3.8 et §8) : le client de l'API les annonce ici, la carte les affiche (voir
 *  `map/dossierWrites.ts`). Ils arrivent en français et passent par `tServer` à l'affichage. Les avis d'un
 *  déploiement (`DeploymentOut.notices`) suivent, eux, l'avis de la modification qui les a produits
 *  (`withOrders`). */

export type ServerNoticesListener = (notices: string[]) => void;

const listeners = new Set<ServerNoticesListener>();

/** Écoute les avis du serveur ; rend le désabonnement. */
export function onServerNotices(listener: ServerNoticesListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Annonce les avis d'une réponse (rien s'il n'y en a pas). */
export function emitServerNotices(notices: readonly string[] | null | undefined): void {
  const list = (notices ?? []).filter((n) => typeof n === "string" && n.trim());
  if (!list.length) return;
  for (const listener of [...listeners]) listener(list);
}
